import { Group } from "../graphic/group";

export const emptyGroup = new Group({});

emptyGroup.role = "empty";
//# sourceMappingURL=empty-group.js.map
